module.exports = "/_next/static/images/owner-59fe37158ba37bd132fb888b0cbfd663.jpg";